// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ecsci","footerLinks":"Footer_footerLinks__Zx8Ya","footerNote":"Footer_footerNote__rvUnk"};